import { api } from "./client.js";
export const auditApi = {
    list: (params = {}) => {
        const search = {};
        if (params.since)
            search.since = params.since;
        if (params.types?.length)
            search.types = params.types.join(",");
        return api.get("api/audit", { searchParams: search }).json();
    },
};
